import { Injectable } from '@angular/core';
import { Globals } from 'app/_globals';

@Injectable()
export class RolePermissionService {
  constructor(
    private globals: Globals,
  ) { }

  private rolePermissions: { [role: string]: SkylarkPermission[] } = {
    'power-station-owner': [
      SkylarkPermission.WRITE__POWER_STATION__ADMIN_DETAILS,
      SkylarkPermission.READ__POWER_STATION__WORKERS,
      SkylarkPermission.READ__CONTRACTORS,
      SkylarkPermission.WRITE__CONTRACTORS,
    ],
    'power-station-manager': [
      SkylarkPermission.READ__POWER_STATION__WORKERS,
      SkylarkPermission.READ__CONTRACTORS,
    ],
    'worker': [
    ],
    'contractor-manager': [
    ],
    'site-delegate': [
      SkylarkPermission.READ__CONTRACTORS,
      SkylarkPermission.WRITE__CONTRACTORS,
    ],
    'authorising-officer': [
      SkylarkPermission.READ__CONTRACTORS,
    ],
    'site-owner': [
      SkylarkPermission.READ__CONTRACTORS,
      SkylarkPermission.WRITE__CONTRACTORS,
    ],
  };

  public hasPermission(permission: SkylarkPermission): boolean {
    const routeRole = this.globals.user.routeRole;
    if (routeRole === 'admin' || routeRole === 'support') {
      return true;
    }

    const rolePermissions = this.rolePermissions[routeRole];
    return rolePermissions ? rolePermissions.includes(permission) : false;
  }
}

export enum SkylarkPermission {
  WRITE__POWER_STATION__ADMIN_DETAILS,
  READ__POWER_STATION__WORKERS,
  READ__CONTRACTORS,
  WRITE__CONTRACTORS,
}
